/**
 * clientInfo
 * a native behavior that returns info about the client behaviors are running on.
 *
 */

import { capitalize } from 'lodash';
import store from '../reducers/storeRegistration';
const getTypeIdentifier = (entityName, content) => {
  var _content;
  return ((_content = content["".concat(entityName.toLowerCase(), "Type")]) === null || _content === void 0 ? void 0 : _content.identifier) || {};
};
export const evaluate = async (entity, entityName, format, content
// parentContentPath,
// transientContext,
// nativeFunctions,
) => {
  const _store$getState$login = store.getState().login.user,
    user = _store$getState$login === void 0 ? {} : _store$getState$login;
  const userID = user.user_id,
    username = user.username,
    firstName = user.firstName,
    lastName = user.lastName,
    customer = user.customer,
    mapboxToken = user.mapboxToken,
    signaturePath = user.signaturePath,
    employeeNumber = user.employeeNumber;
  const formTypeIdentifier = getTypeIdentifier(entityName, content);
  const hasValidMapToken = typeof mapboxToken === 'string' && mapboxToken.trim().length > 0;
  const result = {
    clientType: 'web',
    userID,
    username,
    firstName,
    lastName,
    customer,
    entityName: capitalize(entityName),
    formTypeIdentifier,
    hasValidMapToken,
    signaturePath,
    employeeNumber
  };
  return result;
};
export default {
  evaluate
};